import { DotLegalButton } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import PlanDialogButtonWrapper from "../../plan/planDialogWrapper/planDialogWrapper";
import { usePlanContext } from "../../auth/planProvider/PlanProvider";
import { PurpleLockIcon } from "../../common/icons";
import TransferResponsibilityDialog from "./transferResponsibilityDialog/TransferResponsibilityDialog";
import { UserResponsibilityEntityType } from "../reviewUserResponsibility/ReviewUserResponsibility.type";
import useTransferUserResponsibility from "./TransferUserResponsibility.hooks";

export interface ITransferUserResponsibility {
    onDialogClose?: () => void;
    onTransferComplete?: () => void;
    fromUserId?: string;
    userResponsibilityEntityType?: UserResponsibilityEntityType;
    header?: string;
    buttonType: "primary" | "secondary";
}

function TransferUserResponsibility(props: ITransferUserResponsibility) {
    const { translateString } = useTranslation();
    const { platformFeatures } = usePlanContext();
    const { showDialog, setShowDialog, onDialogClose } = useTransferUserResponsibility(props);

    return (
        <>
            <PlanDialogButtonWrapper
                text={translateString("upgradeToPaidPlanForAccessToTransferUserResponsibility")}
                enabled={!platformFeatures.canTransferUserResponsibility}
            >
                <DotLegalButton
                    buttonType={props.buttonType}
                    onClick={() => setShowDialog(true)}
                    disabled={!platformFeatures.canTransferUserResponsibility}
                    endIcon={!platformFeatures.canTransferUserResponsibility ? PurpleLockIcon : undefined}
                    toolTip={
                        !platformFeatures.canTransferUserResponsibility ? translateString("upgradeToPaidPlanForAccessToTransferUserResponsibility") : undefined
                    }
                >
                    {translateString("transferReponsibility")}
                </DotLegalButton>
            </PlanDialogButtonWrapper>
            {showDialog && <TransferResponsibilityDialog {...props} onDialogClose={onDialogClose} />}
        </>
    );
}

export default TransferUserResponsibility;
